<template>
    <div class="page">
        <div class="container">

            <h1>Short UUID generator</h1>

            <p>This tool allows you to generate an UUID4 in various short formats, such as Base 32, Base 36 or Base
                58.</p>


            <div class="input-container">
                <input class="" type="text" id="" value="" v-bind:value="currentUuid">
                <button class="copy-button"
                        v-clipboard:copy="currentUuid"
                        v-clipboard:success="copySuccess">
                    <span v-html="require('!raw-loader!./file_copy-24px.svg')"></span>
                    <span ref="copyText">Copy</span>
                </button>
            </div>
            <button class="generate-button" v-on:click.prevent="update" v-bind:disabled="loading">
                <span v-html="require('!raw-loader!./sync-24px.svg')"></span>
                <span>Generate new UUID</span>
            </button>



            <h2>UUID format</h2>

            <div class="format">
                <div>
                    <label class="label">
                        <input type="radio" name="example" value="integer" v-model="format">
                        <span class="label-text">
                            <span class="label-top">Decimal</span>
                            <span class="label-bottom">1234567890</span>
                        </span>
                    </label>
                </div>
                <div>
                    <label class="label">
                        <input type="radio" name="example" value="hex_no_dashes" v-model="format">
                        <span class="label-text">
                            <span class="label-top">Base 16 (Hexadecimal)</span>
                            <span class="label-bottom">0123456789abcdef</span>
                        </span>
                    </label>
                </div>
                <div>
                    <label class="label">
                        <input type="radio" name="example" value="hex" v-model="format">
                        <span class="label-text">
                            <span class="label-top">Base 16 (Hexadecimal) with dashes</span>
                            <span class="label-bottom">0123456789abcdef</span>
                        </span>
                    </label>
                </div>
                <div>
                    <label class="label">
                        <input type="radio" name="example" value="base32" v-model="format">
                        <span class="label-text">
                            <span class="label-top">Base 32</span>
                            <span class="label-bottom">abcdefghijklmnopqrstuvwxyz234567</span>
                        </span>
                    </label>
                </div>
                <div>
                    <label class="label">
                        <input type="radio" name="example" value="base32_crockford" v-model="format">
                        <span class="label-text">
                            <span class="label-top">Base 32 (Crockford)</span>
                            <span class="label-bottom">0123456789abcdefghjkmnpqrstvwxyz</span>
                        </span>
                    </label>
                </div>
                <div>
                    <label class="label">
                        <input type="radio" name="example" value="base32_z" v-model="format">
                        <span class="label-text">
                            <span class="label-top">Base 32 (z-base-32)</span>
                            <span class="label-bottom">ybndrfg8ejkmcpqxot1uwisza345h769</span>
                        </span>
                    </label>
                </div>
                <div>
                    <label class="label">
                        <input type="radio" name="example" value="base36" v-model="format">
                        <span class="label-text">
                            <span class="label-top">Base 36</span>
                            <span class="label-bottom">0123456789abcdefghijklmnopqrstuvwxyz</span>
                        </span>
                    </label>
                </div>
                <div>
                    <label class="label">
                        <input type="radio" name="example" value="base58" v-model="format">
                        <span class="label-text">
                            <span class="label-top">Base 58</span>
                            <span class="label-bottom">0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuv</span>
                        </span>
                    </label>
                </div>
                <div>
                    <label class="label">
                        <input type="radio" name="example" value="base62" v-model="format">
                        <span class="label-text">
                            <span class="label-top">Base 62</span>
                            <span class="label-bottom">0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ</span>
                        </span>
                    </label>
                </div>
                <div>
                    <label class="label">
                        <input type="radio" name="example" value="base64" v-model="format">
                        <span class="label-text">
                            <span class="label-top">Base 64</span>
                            <span class="label-bottom">ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/</span>
                        </span>
                    </label>
                </div>
                <div>
                    <label class="label">
                        <input type="radio" name="example" value="base64_url_safe" v-model="format">
                        <span class="label-text">
                            <span class="label-top">Base 64 (URL safe)</span>
                            <span class="label-bottom">ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_</span>
                        </span>
                    </label>
                </div>
                <div>
                    <label class="label">
                        <input type="radio" name="example" value="base85" v-model="format">
                        <span class="label-text">
                            <span class="label-top">Base 85</span>
                            <span class="label-bottom">!"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\]^_`abcdefghijklmnopqrstu</span>
                        </span>
                    </label>
                </div>
            </div>

            <h2>Fine print</h2>

            <p>No guarantees are given about the uniqueness of any IDs generated by this tool. The tool is provided
                "as is", without warranty of any kind, express or implied, including but not limited to the warranties
                of merchantability, fitness for a particular purpose and noninfringement. In no event shall the authors
                or copyright holders be liable for any claim, damages or other liability, whether in an action of
                contract, tort or otherwise, arising from, out of or in connection with the software or the use or other
                dealings in the software.</p>
        </div>
    </div>
</template>

<script>
    import * as axios from "axios";

    export default {
        data: function () {
            return {
                uuid: null,
                format: 'base36',
                loading: true,
            }
        },
        mounted() {
            this.update();
        },
        methods: {
            update: function () {
                this.loading = true;
                axios.get('/api').then(result => {
                    this.loading = false;
                    this.uuid = result.data;
                }).catch((result) => {
                    this.loading = false;
                });
            },
            copySuccess: function () {
                // TODO: maybe make this a prop?
                let originalText = this.$refs.copyText.innerHTML;
                this.$refs.copyText.innerHTML = 'Copied!';
                setTimeout(() => {
                    this.$refs.copyText.innerHTML = originalText;
                }, 1000);
            }
        },
        computed: {
            currentUuid: function () {
                if (!this.uuid) {
                    return null;
                }
                return this.uuid[this.format];
            }
        }
    }
</script>